module.exports = __webpack_public_path__ + "img/27.954dfebd.jpg";